import { Star } from '@material-ui/icons'
import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import ReviewStyle from './Reviews.style'
import * as Yup from "yup";
import api from "@api/Apis";
import { Rating } from '@material-ui/core';
import _ from 'lodash';
import Slider from 'react-slick';
import NumberFormat from 'react-number-format';
import NumberFormatComp from '@Components/Common/NumberFormatComp';
import moment from 'moment';


const initialValues = {
    first_name: "",
    last_name: "",
    zip: "",
    rating: "",
    review_of: "",
    review_on: "",
    review_message: "",

};

const Schema = Yup.object().shape({
    first_name: Yup.string().required('First name is required'),
    last_name: Yup.string().required('Last name is required'),
    zip: Yup.string().required('Zip is required'),
    rating: Yup.string().required('rating is required'),
    review_of: Yup.string().required('this field is required'),
    review_on: Yup.string().notRequired(),
    review_message: Yup.string().required('Review is required'),

});

const settings_3 = {
    dots: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    // centerMode: true,
    // centerPadding: "0",
    // autoplay: true,
    // lazyLoad: 'progressive',
    speed: 1000,
    autoplaySpeed: 5000,
    arrows: true,

    responsive: [
        {
            breakpoint: 1020,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                arrows: true,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                arrows: true,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                arrows: true,
            }
        },

    ],
};

const Reviews = () => {

    const CONTENT_LIST = [
        { review_message: `Love how it's just based off me and not the world!`, color: "prplbx", review_ratings: 5, created_at: "2024-03-11T01:23:00.435056-05:00" },
        { review_message: `Everything I need and more. All in one supplement.`, color: "orange-bx", review_ratings: 5, created_at: "2024-03-12T01:23:00.435056-05:00" },
        { review_message: `My energy and sleep are off the charts`, color: "gree-bx", review_ratings: 5, created_at: "2024-03-13T01:23:00.435056-05:00" },
    ];
    const [showMsg, setShowMsg] = useState('');
    const [reviewData, setReviewData] = useState({
        initialReviews: CONTENT_LIST,
        reviewsData: []
    });

    useEffect(() => {
        api.snipReviewsApi({}, "get").then((res) => {
            if (res?.data?.code === 1) {
                setReviewData((prevData) => ({
                    ...prevData,
                    reviewsData: Array.isArray(res?.data?.reviews_data) ? res?.data?.reviews_data : []
                }));
            }
        });
    }, []);

    const combinedReviews = reviewData?.initialReviews?.concat(reviewData?.reviewsData);

    const { values, errors, touched, handleChange, handleSubmit } = useFormik({
        initialValues,
        validationSchema: Schema,
        onSubmit: (values, action) => {
            api.snipReviewsApi(values, "post").then((res) => {
                if (res?.data?.code === 1) {
                    setShowMsg(res?.data?.message);
                    action.resetForm();
                    setTimeout(() => {
                        setShowMsg('');
                    }, 3000);
                } else {
                    console.log("Error during submission: ", res?.data?.message);
                }
            });
        },
    });

    return (
        <ReviewStyle>
            <div className="user-reviews">
                <div className='container'>
                    <div className='row'>
                        <div className='review-section'>
                            <h3>LEAVE US A REVIEW</h3>
                            <p>What do you think of your SNiP DNA reports and CODE Complex customized supplement?</p>
                            <div className='own-review'>
                                <div>Submit your own review here!</div>
                            </div>
                            <div className='own-review-par'>
                                <p>We strive to provide the highest quality personalized products and customer service to all our customers. Your satisfaction is important to us and we greatly value your feedback.
                                </p>
                                <p>Share your story by submitting a review of SNiP Nutrigenomics below. Thank you!</p>
                            </div>
                        </div>
                        <div className='reviews-data'>
                            <form onSubmit={handleSubmit}>
                                <div className='mb-3 form-check field-class'>
                                    <input
                                        type='text'
                                        className='form-control'
                                        name='first_name'
                                        placeholder='First name*'
                                        value={values?.first_name}
                                        onChange={handleChange}
                                        error={!!errors?.first_name}
                                        errorMessage={errors?.first_name}
                                    />
                                    {errors?.first_name && <div className='error-show' >{errors?.first_name}</div>}
                                </div>
                                <div className='mb-3 form-check field-class'>
                                    <input
                                        type='text'
                                        className='form-control'
                                        name='last_name'
                                        placeholder='Initial (Last name)'
                                        value={values?.last_name}
                                        onChange={handleChange}
                                        error={!!errors?.last_name}
                                        errorMessage={errors?.last_name}
                                    />
                                    {errors?.last_name && <div className='error-show'>{errors?.last_name}</div>}
                                </div>
                                <div className='mb-3 form-check field-class'>
                                    <input
                                        type='text'
                                        className='form-control'
                                        name='zip'
                                        placeholder='Zip*'
                                        value={values?.zip}
                                        onChange={handleChange}
                                        error={!!errors?.zip}
                                        errorMessage={errors?.zip}
                                    />
                                    {errors?.zip && <div className='error-show'>{errors?.zip}</div>}
                                </div>
                                <div className='mb-3 form-check field-class'>
                                    <select id='review' name='review_of' value={values?.review_of} onChange={handleChange}>
                                        <option value=''>Select</option>
                                        <option value='dna-reports'>DNA Reports</option>
                                        <option value='nutritional-supplement'>
                                            CODE Complex DNA-personalized nutritional supplement
                                        </option>
                                        <option value='nutritional supplement-reports'>
                                            CODE Complex DNA-personalized nutritional supplement + DNA Reports
                                        </option>
                                        <option value='Other'>Other</option>
                                    </select>
                                </div>
                                {errors?.review_of && <div className='error-show'>{errors?.review_of}</div>}
                                <div className='mb-3 form-check field-class'>
                                    <Rating
                                        name="rating"
                                        value={values?.rating}
                                        onChange={handleChange}

                                        sx={{ color: "#fff" }}
                                        emptyIcon={<Star style={{ opacity: 0.55, color: "#fff" }} fontSize="inherit" />}
                                        error={!!errors?.rating}
                                        errorMessage={errors?.rating}
                                    />
                                    {errors?.rating && <div className='error-show'>{errors?.rating}</div>}
                                </div>
                                <div className='mb-3 form-check field-class'>
                                    <label>Review:</label>
                                    <input
                                        type='text'
                                        className='form-control'
                                        name='review_message'
                                        value={values?.review_message}
                                        onChange={handleChange}
                                        error={!!errors?.review_message}
                                        errorMessage={errors?.review_message}
                                    />
                                    {errors?.review_message && <div className='error-show'>{errors?.review_message}</div>}
                                </div>
                                <div className='mb-3 form-check field-class'>

                                    <input
                                        type="hidden"
                                        className='form-control'
                                        name='review_on'
                                        onChange={handleChange}
                                        error={!!errors?.review_on}
                                        errorMessage={errors?.review_on}
                                    />

                                </div>
                                <div className='btn-submit'>
                                    <button type='submit' className='btn-primary'>Submit</button>
                                </div>
                            </form>
                            <div className="message-show">{showMsg}</div>
                            <div className='review_section'>
                                <div className='rating_section_content' >
                                    <Slider {...settings_3}>
                                        {_.map(combinedReviews, ({ review_message, color, review_ratings, created_at, user_name }, index) => (
                                            <div key={index}>
                                                <div className={`contain-bx ${color}`}>
                                                    <p>“{review_message}”</p>
                                                    <Rating
                                                        name="rating"
                                                        value={review_ratings}
                                                        readOnly
                                                        sx={{ color: "black" }}
                                                        emptyIcon={<Star style={{ opacity: 0.55 }} fontSize="inherit" />}
                                                    />
                                                    <span>Review submitted</span>
                                                    <p>{moment(created_at)?.format('MM-DD-YYYY')}</p>
                                                    <p>{user_name}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </Slider>
                                </div>
                                <div className='images-sections'>
                                    <img src='images/dance-girl.png' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ReviewStyle>
    )
}

export default Reviews